import styled from '../../../styles/theme';
import { AlertStyled } from '../AlertStyled';

export const AlertStyledAC = styled(AlertStyled)`
    .wrapper {
        background: ${({ theme }) => theme.colors.primary};
    }
`;
